import {Component, handler} from "../Component";
import {element} from "../CustomElement";
import {inject} from "../../services/di";
import {ConfigService, DistributionMode} from "../../services/ConfigService";
import {UserAgentService} from "../../services/UserAgentService";
import {StorageService} from "../../services/StorageService";
import {EventService} from "../../services/EventService";
import {LocationService} from "../../services/LocationService";
import {icons} from "../../icons/Icons";
import {AppRating} from "../flipp-app-rating/AppRating";
import { i18n } from "../../i18n/I18n";
import {isLightHouse} from "../../utils/crawler";

interface IMobileBanner {
	whenWasHiddenName: string;
}
export interface MobileBannerProps extends JSX.HTMLProps {
	checkAppBanner?: any;
}

@element("mobile-banner")
export class MobileBanner extends Component<MobileBannerProps, {}> implements IMobileBanner {
	@handler checkAppBanner: any;

	@inject config: ConfigService;
	@inject userAgent: UserAgentService;
	@inject storageService: StorageService;
	@inject eventService: EventService;
	@inject locationService: LocationService;

	whenWasHiddenName = "when-was-hidden-mobile-banner";

	isBannerHidden() {
		if (isLightHouse()) {
			return true;
		}

		const whenWasHidden = Cookies.get(this.whenWasHiddenName);
		if (this.checkAppBanner) {
			this.checkAppBanner(whenWasHidden);
		}
		if (!this.userAgent.mobile || this.config.DISTRIBUTION_MODE !== DistributionMode.NONE) {
			return true;
		}
		if (whenWasHidden === null) {
			return false;
		}
		return Math.abs((new Date()).getTime() - parseInt(whenWasHidden)) <= 864e5;
	}

	isAppInstalled() {
		return false;
	}

	getLinkTitle() {
		return this.userAgent.iOS ? "Flipp for iPhone" : "Flipp for Android";
	}

	getLinkButtonText() {
		return this.isAppInstalled() ? "Open" : i18n("get_app");
	}

	hideBanner() {
		Cookies.set(this.whenWasHiddenName, (new Date()).getTime().toString(), {
			expires: 1,
			domain: this.config.getCookiesDomain()
		});
		this.invalidate();
		this.eventService.mobileBannerClosed();
	}

	render() {
		const textClassAppendix = this.locationService.locale === "fr-ca" ? " french" : "";
		const textClass = "mobile-banner__links__body" + textClassAppendix;
		const buttonClass = "mobile-banner__links__button" + textClassAppendix;
		if (this.isBannerHidden()) {
			return null;
		}
		return <div class="mobile-banner">
				<div class="mobile-banner__close" onClick={this.hideBanner.bind(this)}>
					<div>
						<img class="myCloseIcon" src="https://f.wishabi.net/creative/Distribution/images/icons/myCloseIcon.svg" alt=""/>
					</div>
				</div>
				<div class="mobile-banner__logo">
					<div>{icons.flippLogo}</div>
				</div>
				<div class="mobile-banner__links">
					<div class="mobile-banner-wrapper">
					<div class={textClass}>
						{i18n("mobile_banner")}
					</div>
						<div class="mobile-banner-rating">
							<AppRating />
						</div>
					</div>
					<div class="mobile-banner-btn-wrapper">
					<div class={buttonClass}>
						<a href="https://flipp.app.link/UpUv09zUy7">{this.getLinkButtonText()}</a>
					</div>
					</div>
				</div>
			</div>;
	}
}
